/**
 * Centralized Brand Configuration
 * Change logo/brand details here and it updates everywhere (Navbar, Footer, Admin, SEO, etc.)
 */

export const BRAND = {
  name: 'Prop Assist',
  tagline: 'We Assist. You Choose.',
  description: 'Pune\'s trusted real estate advisory. Expert guidance on premium residential & commercial properties.',
  
  // Logos - change these URLs to update everywhere
  logoWhite: 'https://customer-assets.emergentagent.com/job_propassist-enhanced/artifacts/5vzz117s_Logo_white.png',
  favicon: '/favicon.ico',
  ogImage: '/og-image.jpg',
  appleTouchIcon: '/apple-touch-icon.png',
  
  // Contact
  phone: '+91 84594 58536',
  email: 'sales@propassist.in',
  whatsapp: 'https://wa.me/918459458536',
  address: '303, West Avenue, Opp. PMRDA Office, Aundh, Pune - 411067',
  // Google Business Profile ("PropAssist" listing, kgmid /g/11mm95s7tx)
  googleMapsUrl: 'https://maps.app.goo.gl/cggJupXE9Ss6edyZ9',
  googleMapsEmbed: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1891.0!2d73.8135037!3d18.5637258!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2bffbb9ebc4e1%3A0x6536c08e5de42602!2sPropAssist!5e0!3m2!1sen!2sin',
  geo: { lat: 18.5637258, lng: 73.8135037 },
  
  // Social
  website: 'https://www.propassist.in',
  
  // SEO
  defaultTitle: 'Prop Assist - Premium Real Estate Advisory in Pune',
  titleSuffix: ' | Prop Assist',
};
